import { Typography, Link } from '@ace-clublabs/shared-component-library';

export interface IParkingSpotDisclaimerProps {
  hasExistingAccount: boolean;
}

export const ParkingSpotDisclaimer = ({ hasExistingAccount }: IParkingSpotDisclaimerProps) => {
  const termsAndConditionsLink = (
    <Link
      variant="b3Regular"
      className="parking-spot-terms"
      href="https://www.theparkingspot.com/the-spot-club-terms"
      target="_blank"
    >
      theSpotClub<sup style={{ fontSize: '0.6rem' }}>®</sup> Program Terms and Conditions
    </Link>
  );

  const privacyPolicyLink = (
    <Link
      variant="b3Regular"
      className="parking-spot-privacy-policy"
      href="https://www.theparkingspot.com/privacy-policy"
      target="_blank"
    >
      Privacy Policy
    </Link>
  );

  const newMemberDisclaimer = (
    <Typography className="parking-spot-disclaimer" variant="b3Regular" sx={{ color: '#404040' }}>
      By selecting the checkbox and clicking "Continue", I agree to join the Spot Club and to {termsAndConditionsLink}{' '}
      and {privacyPolicyLink} at The Parking Spot. I also consent to share my name, AAA number, and email address with
      The Parking Spot to receive my AAA member benefits.{' '}
      <strong>By deselecting the box, my information will not be shared.</strong>
    </Typography>
  );

  const existingMemberDisclaimer = (
    <Typography className="parking-spot-disclaimer" variant="b3Regular" sx={{ color: '#404040' }}>
      By selecting the checkbox and clicking "Continue", I agree to have my AAA number added to my Spot Club account and
      agree to {termsAndConditionsLink} and {privacyPolicyLink} at The Parking Spot.{' '}
      <strong>By deselecting the box, my information will not be shared.</strong>
    </Typography>
  );

  if (hasExistingAccount) {
    return existingMemberDisclaimer;
  } else {
    return newMemberDisclaimer;
  }
};
